






















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import ActionShowButtonI from '@/modules/shared/components/shared/table/action/ActionShowButtonI.vue'
import { AdminUserRoutes } from '@/modules/user/routes/admin-user.route'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import AdminUserSwitchButton from '@/modules/user/components/admin/AdminUserSwitchButton.vue'

@Component({
  components: {
    AdminUserSwitchButton,
    BaseButton,
    ActionShowButtonI
  }
})
export default class AdminUserTableActions extends Vue {
  constructor(
    private readonly routes: AdminUserRoutes
  ) {
    super()
  }

  @Prop({ required: true }) userId: number

  protected get userShowPageLink() {
    return this.routes.show(this.userId)
  }

  protected get userWalletPageLink() {
    return this.routes.wallet(this.userId)
  }

  protected get switchToUserLink() {
    return this.routes.switchToUser(this.userId)
  }
}
